import { choosePlural } from '@experience/shared/dist/utils/pluralize';
import { DAY_HOURS } from '../../const/config.ts';
import { useTourFiltersStore } from '@/entities/filter/store/tour';
import { useComponentI18n } from '@/shared/composables/useComponentI18n.ts';
import type ru from '../../i18n/ru.json';

type TSchema = typeof ru;

export function useTourFilterDurationTitle(messages: TSchema) {
  const { t } = useComponentI18n({ ru: messages });

  const filterStore = useTourFiltersStore();

  const DEFAULT_TITLE = t('duration.defaultTitle');

  const headerTitle = ref(t('duration.headerTitle'));

  const PLURAL_DAYS = [t('duration.day_1'), t('duration.day_2'), t('duration.day_2')];

  const title = computed(() => {
    const duration = filterStore.searchState.duration;

    const start = duration[0] ? duration[0] / DAY_HOURS : null;
    const end = duration[1] ? duration[1] / DAY_HOURS : null;

    if (start === null && end === null) {
      return DEFAULT_TITLE;
    }

    if (start && end === null) {
      return `${t('duration.fromDay', { day: start })} ${choosePlural(start, PLURAL_DAYS)}`;
    }

    if (end && start === null) {
      return `${t('duration.toDay', { day: end })} ${choosePlural(end, PLURAL_DAYS)}`;
    }

    if (start && end) {
      return `${t('duration.fromDay', { day: start })} ${t('duration.toDay', { day: end })} ${choosePlural(end, PLURAL_DAYS)}`;
    }

    return DEFAULT_TITLE;
  });

  const isActive = computed(() => title.value !== DEFAULT_TITLE);

  return {
    title,
    headerTitle,
    isActive,
  };
}
